import { render, staticRenderFns } from "./CreateBoardItemIcon.vue?vue&type=template&id=342612a0&scoped=true"
import script from "./CreateBoardItemIcon.vue?vue&type=script&lang=js"
export * from "./CreateBoardItemIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342612a0",
  null
  
)

export default component.exports